// iframe路由
export default {
  path: '/shopiframe',
  component: () =>
    import(/* webpackChunkName: "shop-iframe" */ '@/components/shopAdminIframe/index.vue'),
  name: 'shop端'
}
